import { handleActions } from 'redux-actions'

import * as rawActions from '../actions'

const defaultState = false

export default handleActions(
  {
    [rawActions.startLoading](state, action) {
      return true
    },
    [rawActions.stopLoading](state, action) {
      return defaultState
    },
    [rawActions.resetGalleryState](state, action) {
      return defaultState
    },
  },
  defaultState
)
